import { cn } from "@lib/cn";

/**
 * CSV file glyph used by the data-variable row and the "Add data" dialog header
 * (Figma 111:34173 / 642:51593): a document outline with a "csv" tab.
 */
export const CsvFileIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    className={cn("tw-shrink-0", className)}
  >
    <path
      d="M9.333 1.667H4.667a1 1 0 0 0-1 1v10.666a1 1 0 0 0 1 1h6.666a1 1 0 0 0 1-1V4.667L9.333 1.667Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M9.167 1.833v2.5a.5.5 0 0 0 .5.5h2.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <text
      x="8"
      y="12"
      textAnchor="middle"
      fill="currentColor"
      style={{ font: "bold 4.2px sans-serif" }}
    >
      csv
    </text>
  </svg>
);
